export default '7F7B9';
